export default "__VITE_ASSET__eb7687fb__"